// Copyright (c) 2021 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import DealershipModal from './dealership-modal';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../labeled-string';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {buildDealer} from '../../../shared/services/build-dealer';

const DealershipWithModal = props =>
    <div className='dealership-with-modal'>
        {props.laborRateAll.length > 0 &&
            <div>
                <div className='dealsership'>
                    <LabeledString
                        className='dealership-last-updated'
                        data={buildDealer(props.laborRateAll[0].responsibleAccount, '01')}
                        label='DEALERSHIP'
                    />
                    {props.laborRateAll.length > 1 &&
                        <span
                            className='open-dealership-modal-link'
                            onClick={props.onDealershipModalOpen}
                        >
                            <FormattedMessage id='MORE'/>
                        </span>
                    }
                </div>
                <DealershipModal
                    isModalOpen={props.isDealershipModalOpen}
                    laborRateAll={props.laborRateAll}
                    onCloseButtonClick={props.onDealershipModalClose}
                />
            </div>
        }
    </div>;

DealershipWithModal.displayName = 'DealershipWithModal';
DealershipWithModal.propTypes = {
    isDealershipModalOpen: PropTypes.bool.isRequired,
    laborRateAll: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    onDealershipModalClose: PropTypes.func.isRequired,
    onDealershipModalOpen: PropTypes.func.isRequired
};

export default DealershipWithModal;



// WEBPACK FOOTER //
// ./src/shared/components/dealership-detail-modal/index.js